import { wp, api } from '@/utils/client';

const state = {
	detail: {
		name: '', boxes_count: null, total_price: null, req_content: '', status: '', created_at: '', files:[]
	},
	index: {meta: {total: 0, last_page:1, current_page:1}, data:[]},
}

// actions
const actions = {
	async fetchSingleEventCampaigns(context, page = {}) {
		try {
			let response = await api.get('/teams/'+ context.rootState.teamId +'/se-campaigns', {params:page});
			context.commit('fetchSingleEventCampaigns', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchSingleEventCampaign(context, campaignId) {
		try {
			let response = await api.get('/se-campaigns/' + campaignId);
			context.commit('fetchSingleEventCampaign', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async createSingleEventCampaign(context, data) {
		try {
			let response = await api.post('/teams/'+ context.rootState.teamId +'/se-campaigns', data);
			context.commit('fetchSingleEventCampaign', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async updateSingleEventCampaign(context, data) {
		try {
			let response = await api.put('/se-campaigns/' + data.id, data.payload);
			context.commit('fetchSingleEventCampaign', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async uploadSingleEventFile(context, {campaignId, payload}) {
		try {
			let response = await api.post('/se-campaigns/' + campaignId + '/files', payload);
			context.commit('refreshSingleEventFiles', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async deleteSingleEventFile(context, {fileId}) {
		try {
			let response = await api.delete('/se-campaigns/files/' + fileId);
			context.commit('deleteSingleEventFile', fileId);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async downloadSingleEventFile(context, {fileId}) {
		try {
			let response = await api.get('/se-campaigns/files/' + fileId);
			console.log(response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	// async uploadCorporateLogo(context, data) {
	// 	try {
	// 		let response = await api.post('/my-corporate/upload', data);
	// 		console.log(response);
	// 	} catch (e) { console.log(e); throw e; }
	// },
}
// mutations
const mutations = {
	fetchSingleEventCampaigns(state, data) {
		state.index = data;
	},
	fetchSingleEventCampaign(state, data) {
		state.detail = data;
	},
	deleteSingleEventFile(state, fileId) {
		state.detail.files.splice(state.detail.files.findIndex(e => e.file_id == fileId),1);
	},
	refreshSingleEventFiles(state, data) {
		state.detail.files = data;
	},
}

export default {
	state,
	actions,
	mutations
}
